import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { Amplify, Auth } from "aws-amplify";
import aws_exports from "./aws-exports.generated";
import "./index.css";
import "semantic-ui-css/semantic.min.css";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import App from "./App.jsx";
import OrganizationTheme from "./ui/OrganizationTheme";
import "react-quill/dist/quill.snow.css"; // Theme styling

// NODE_ENV is "production" in every CRA build, so it can't tell main from
// staging or develop. REACT_APP_ENVIRONMENT (set per Amplify branch) does.
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV,
  enabled: !!process.env.REACT_APP_SENTRY_DSN,
  tracesSampleRate: 0.2,
});

// Origin-based so localhost, the custom domain, and every Amplify branch
// domain work without a rebuild. Each origin must still be listed in the
// Cognito app client's callback/sign-out URLs.
const redirectUrl = `${window.location.origin}/`;

/* aws-exports.generated.js omits oauth entirely when no hosted-UI domain is
   configured, so don't put an empty one back: Amplify throws on an oauth block
   with no user pool behind it. */
const updatedConfig = aws_exports.oauth
  ? {
      ...aws_exports,
      oauth: {
        ...aws_exports.oauth,
        redirectSignIn: redirectUrl,
        redirectSignOut: redirectUrl,
      },
    }
  : aws_exports;

Amplify.configure(updatedConfig);
Auth.configure(updatedConfig);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <OrganizationTheme>
        <App />
      </OrganizationTheme>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
